export default __webpack_public_path__ + "static/media/AskMeLogoOptimized.4d197a75.jp2";